import { ApiKey, ApiPathManager } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader } from "app/shared/services/header-builder";
import { REQUESTINPUT } from "app/shared/services/services-model.type";
import { instance } from "app/shared/util/token-store";
import { FetchTransHistoryRequest } from "../reducer/types";

const getStatus = (status?: string) => {
  if (status && status?.length > 0) {
    return status.substr(status.length - 1, 1);
  }
  return "";
};

export const fetchTransHistoryService = async (actionRq: FetchTransHistoryRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.ACCOUNT_TRANSACTION_HISTORY);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ACCOUNTPROFILE: {
      ACCOUNTNO: actionRq.payload?.accountNo,
      RCDSTAT: actionRq.payload?.advanced,
      CONTENT: actionRq.payload?.content,
      STATUS: getStatus(actionRq.payload?.status),
    },
    STATEMENT: {
      FROMDATE: actionRq.payload?.fromDate,
      TODATE: actionRq.payload?.toDate,
      BEGINBALANCE: actionRq.payload?.minCurrency,
      ENDBALANCE: actionRq.payload?.maxCurrency,
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};
